import { render, staticRenderFns } from "./BannersPage.vue?vue&type=template&id=1e987df6&"
import script from "./BannersPage.vue?vue&type=script&lang=js&"
export * from "./BannersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports